import React, { useState } from "react";
import { Button, Card, Modal, Title } from "@mantine/core";

import { PrizeForm, PrizeList } from "./";

export default function PrizeManagement({
  contestId,
  locationId,
  organizationId,
  fetchData,
  isPrizePool = false,
  isAuction = false,
  minimal,
  onModalClose,
  showPrizeEdit = true,
  contestForDuplication = false,
}) {
  const [refresh, setRefresh] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  function onClose() {
    setModalOpen(false);

    if (onModalClose) {
      return onModalClose();
    }
  }

  return (
    <div>
      {!isPrizePool && !isAuction && (
        <Button
          mb="sm"
          // variant="light"
          onClick={() => setModalOpen(true)}
        >
          Create Prize
        </Button>
      )}
      <Modal title="Create Prize" opened={modalOpen} onClose={onClose}>
        <PrizeForm
          contestId={contestId}
          onSuccess={() => {
            setRefresh(!refresh);
            setModalOpen(false);
            if (fetchData) {
              fetchData();
            }
          }}
        />
      </Modal>
      <PrizeList
        contestForDuplication={contestForDuplication}
        contestId={contestId}
        isAuction={isAuction}
        isPrizePool={isPrizePool}
        locationId={locationId}
        minimal={minimal}
        onModalClose={onModalClose}
        organizationId={organizationId}
        refresh={refresh}
        showPrizeEdit={showPrizeEdit}
      />
    </div>
  );
}
